import { useEffect, useState } from "react";
import "../radio-buttons.css";

export function TypeOfTransport(props) {
  const plateBuilder = props.plateBuilder;
  const [activeClassName, setActiveClassName] = useState(true);

  useEffect(() => {
    setActiveClassName(
      props.choosedOption.typeOfTransport == "car" ? true : false
    );
  }, [props.choosedOption.typeOfTransport]);
 

  const updateTypeOfTransport = (type) => {
    if (type === "car") {
      props.choosedOption.fontStyle === "CharlesWright Motorcycle"
        ? props.updateChoosedOptions({
            typeOfTransport: "car",
            frontPlate: "true",
            rearPlate: "true",
            plateSizeRear: "Standard Car Oblong (20.5x4.4in)",
            plateSizeFront: "Standard Car Oblong (20.5x4.4in)",
            breakLine: "false",
            fontStyle: "CharlesWright Bold",
          })
        : props.updateChoosedOptions({
            typeOfTransport: "car",
            frontPlate: "true",
            rearPlate: "true",
            plateSizeRear: "Standard Car Oblong (20.5x4.4in)",
            plateSizeFront: "Standard Car Oblong (20.5x4.4in)",
            breakLine: "false",
          });
    } else {
      props.choosedOption.fontStyle === "CharlesWright Bold" ||
      props.choosedOption.fontStyle === "null"
        ? props.updateChoosedOptions({
            typeOfTransport: "motorbike",
            frontPlate: "false",
            rearPlate: "true",
            fullHeightBadge: "false",
            plateSizeRear: "Standard Motorcycle (9x7in)",
            plateSizeFront: "Standard Motorcycle (9x7in)",
            breakLine: "true",
            fontStyle: "CharlesWright Motorcycle",
          })
        : props.updateChoosedOptions({
            typeOfTransport: "motorbike",
            frontPlate: "false",
            rearPlate: "true",
            fullHeightBadge: "false",
            plateSizeRear: "Standard Motorcycle (9x7in)",
            plateSizeFront: "Standard Motorcycle (9x7in)",
            breakLine: "true",
          });
    }
  };
  return (
    <div className="radio-buttons flex flex-wrap items-center">
      <div
        className={
          activeClassName
            ? " radio-buttons__radio radio-buttons__radio--active"
            : " radio-buttons__radio"
        }
        onClick={() => updateTypeOfTransport("car")}
      >
        Car
      </div>

      <div
        className={
          !activeClassName
            ? " radio-buttons__radio radio-buttons__radio--active"
            : " radio-buttons__radio"
        }
        onClick={() => updateTypeOfTransport("motorbike")}
      >
        Motorbike
      </div>
    </div>
  );
}
